import React, { useState, useEffect } from "react";
import {
  Grid,
  Typography,
  Button,
  TextField,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Checkbox,
  FormControlLabel,
  FormControl,
  InputLabel,
  Select,
  ListItemText,
  Input,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Card, Alert } from "reactstrap";
import { getWalletOwnerIdAndNameList } from "../../redux/actions/getWalletOwnerIdAndNameListAction";
import Layout from "../../components/Wrappers/Layout";
import BackButton from "../../components/BackButton/BackButton";
import { useDispatch, useSelector } from "react-redux";
import {
  adminGetTransferTypeList,
  resetAdminGetTransferTypeList,
} from "../../redux/actions/adminGetTransferTypeListAction";
import { adminTransferTypeMappping } from "../../redux/actions/adminTransferTypeMapppingAction";
import { adminGetTransferTypeMappingList } from "../../redux/actions/adminGetTransferTypeMappingListAction";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import CustomButton from "../../components/CustomButton/CustomButton";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import { adminGetAccountTypeList } from "../../redux/actions/adminGetAccountTypeListAction";
import { Delete } from '@mui/icons-material';
import { adminDeleteTransferTypeMapping } from "../../redux/actions/adminDeleteTransferTypeMappingAction";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import { adminTransferTypeMapppingCompare } from "../../redux/actions/adminTransferTypeMappingCompareAction";
import val from "../../getThemeDetails";
const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

const AdminTransferTypeMapping = () => {
  const classes = useStyles();

  const dispatch = useDispatch();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [walletOwnerIdResp, setwalletOwnerIdResp] = useState([]);
  const [walletOwnerID, setwalletOwnerID] = useState("");
  const [transferTypeList, settransferTypeList] = useState([]);
  const [transferTypes, settransferTypes] = useState([]);
  const [searchWalletOwnerID, setsearchWalletOwnerID] = useState("");
  const [setSearch, setsetSearch] = useState(false);
  const [transferTypeMappingArr, settransferTypeMappingArr] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [deleteSet, setdeleteSet] = useState(false);
  const [deleteDescription, setdeleteDescription] = useState("");
  const [deleteNotify, setdeleteNotify] = useState(false);
  const [createSet, setcreateSet] = useState(false);
  const [mappingDescription, setmappingDescription] = useState("");
  const [notificationOpen, setnotificationOpen] = useState(false);
  const [bankType, setbankType] = useState("");
  const [bankTypeList, setbankTypeList] = useState([]);
  const [ttListSet, setttListSet] = useState(false);

  const getWalletOwnerIdRes = useSelector(
    ({ getWalletOwnerIdAndNameList }) => getWalletOwnerIdAndNameList
  );
  const adminTransferTypeMappingRes = useSelector(
    ({ adminTransferTypeMapping }) => adminTransferTypeMapping
  );
  const adminGetTransferTypeMappingListRes = useSelector(
    ({ adminGetTransferTypeMappingList }) => adminGetTransferTypeMappingList
  );
  const adminGetTransferTypeListRes = useSelector(
    ({ adminGetTransferTypeList }) => adminGetTransferTypeList
  );
  const adminDeleteTransferTypeMappingRes = useSelector(
    ({ adminDeleteTransferTypeMapping }) => adminDeleteTransferTypeMapping
  );
  const adminGetAccountTypeListRes = useSelector(
    ({ adminGetAccountTypeList }) => adminGetAccountTypeList
  );
  const regenerateTokenRes = useSelector(
    ({ regenerateToken }) => regenerateToken
  );
  const adminGetTransferTypeMappingListCompareRes = useSelector(
    ({ adminGetTransferTypeListCompare }) => adminGetTransferTypeListCompare
  );

  var authToken = regenerateTokenRes.data.AuthToken;

  const getTrasferTypeMappingResp = () => {
    if (createSet) {
      if (adminTransferTypeMappingRes.data.status === "success") {
        setmappingDescription(adminTransferTypeMappingRes.data.description);
        setnotificationOpen(true);
        setcreateSet(false);
        submitsearchfunc();
      }
      if (adminTransferTypeMappingRes.data.status === "failed") {
        setmappingDescription(adminTransferTypeMappingRes.data.description);
        setnotificationOpen(true);
        setcreateSet(false);
        if (adminTransferTypeMappingRes.data.description == "session out") {
          SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
        }
        if (
          adminTransferTypeMappingRes.data.description == "Authorization failed"
        ) {
          regenerateToken(
            dispatch,
            authToken,
            regenerateTokenRes.data.partnerId
          );
        }
      }
    }
  };

  useEffect(() => {
    getTrasferTypeMappingResp();
  }, [adminTransferTypeMappingRes.data.status]);

  const handleNoticationClose = () => {
    setnotificationOpen(false);
    setmappingDescription("");
  };

  const getWalletOwnerIdFunc = () => {
    dispatch(
      getWalletOwnerIdAndNameList(
        {
          loginDetails: {
              adminId:val.adminIDS
            // adminId: regenerateTokenRes.data.partnerId,
          },
        },
        authToken
      )
    );
  };

  useEffect(() => {
    getWalletOwnerIdFunc();
  }, [authToken]);

  useEffect(() => {
    console.log("adminGetTransferTypeListRessss", adminGetTransferTypeListRes);
    if (adminGetTransferTypeListRes.data.status) getTransferTypeResp();
  }, [adminGetTransferTypeListRes]);

  //   useEffect(() => {}, [adminGetTransferTypeMappingListCompareRes]);
  // useEffect(() => {
  //   return () => { setbankTypeList([]) }

  // }, [])
  useEffect(() => {
    if (getWalletOwnerIdRes.data.status === "success") {
      setwalletOwnerIdResp(getWalletOwnerIdRes.data.ownerList);
    }
    if (getWalletOwnerIdRes.data.status === "failed") {
      if (getWalletOwnerIdRes.data.description == "session out") {
        SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
      }
      if (getWalletOwnerIdRes.data.description == "Authorization failed") {
        regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
      }
    }
  }, [getWalletOwnerIdRes.data.status]);

  const getTransferTypeResp = () => {
    if (adminGetTransferTypeListRes.data.status === "success") {
      console.log(
        "trnsfffer",
        adminGetTransferTypeListRes.data.customerMasterDetailsRequestVOList
      );
      settransferTypeList(
        adminGetTransferTypeListRes.data.customerMasterDetailsRequestVOList
      );
      console.log(
        "valuesss",
        walletOwnerID,
        bankType.split("-")[1],
        adminGetTransferTypeMappingListCompareRes.data.list,
        adminGetTransferTypeListRes.data.customerMasterDetailsRequestVOList
      );
      if (bankType && adminGetTransferTypeMappingListCompareRes.data.description != "List Not Retrieved") {
        finalTT(
          walletOwnerID,
          bankType.split("-")[1],
          [].concat(adminGetTransferTypeMappingListCompareRes.data.list),
          [].concat(
            adminGetTransferTypeListRes.data.customerMasterDetailsRequestVOList
          )
        );
      }
    }
    if (adminGetTransferTypeListRes.data.status === "failed") {
      if (adminGetTransferTypeListRes.data.description == "session out") {
        SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
      }
      if (
        adminGetTransferTypeListRes.data.description == "Authorization failed"
      ) {
        regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
      }
    }
  };

  useEffect(() => {
    setTransferTypeMappingList();
  }, [adminGetTransferTypeMappingListRes.data.status]);

  const setTransferTypeMappingList = () => {
    if (setSearch) {
      if (adminGetTransferTypeMappingListRes.data.status === "success") {
        settransferTypeMappingArr(
          [].concat(adminGetTransferTypeMappingListRes.data.list)
        );
        setisLoading(false);
      }
      if (adminGetTransferTypeMappingListRes.data.status === "failed") {
        settransferTypeMappingArr([]);
        setisLoading(false);
        if (
          adminGetTransferTypeMappingListRes.data.description == "session out"
        ) {
          SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
        }
        if (
          adminGetTransferTypeMappingListRes.data.description ==
          "Authorization failed"
        ) {
          regenerateToken(
            dispatch,
            authToken,
            regenerateTokenRes.data.partnerId
          );
        }
      }
    }
  };

  const finalTT = (wid, btype, mainArr, ttone) => {
    console.log("inside final", wid, btype, mainArr, ttone);
    // let mapped = [].concat(mainArr).filter(ch => ch.bankType === btype && ch.walletOwnerId === wid).map(x => x.name);
    // for (let i = 0; i < ttone.length; i++) {
    //     ttone[i].disabled = false;

    //     for (let j = 0; j < mapped.length; j++) {
    //         if (ttone[i].name === mapped[j]) {
    //             ttone[i].disabled = true;
    //             break;
    //         }
    //     }
    // }
    console.log("ttooone", ttone);
    for (let i = 0; i < ttone.length; i++) {
      let checkId = ttone[i].id;
      console.log("checkId", checkId);
      console.log("mainArrr", mainArr);
      for (let j = 0; j < mainArr.length; j++) {
        console.log("mainEl", mainArr[j]);

        if (checkId == mainArr[j].id && mainArr[j].bankType == btype) {
          ttone[i].disabled = true;
          console.log("toneEl", ttone[i]);
        }
      }
    }
    console.log(ttone, "updateTone");
    settransferTypeList(ttone);
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    if (name === "transferTypes") {
      if (value.includes("all")) {
        console.log("TRANSFERRR", transferTypeList);
        settransferTypes(
          transferTypes.length ===
            transferTypeList.filter((ch) => !ch.disabled).length
            ? []
            : transferTypeList.filter((ch) => !ch.disabled).map((x) => x.name)
        );
      } else {
        settransferTypes(value);
      }
    }
    if (name === "walletOwnerID") {
      // getTransferTypeList();
      setbankType("");
      setwalletOwnerID(value);
      getBankTypeList();
    }
    if (name === "bankType") {
      setbankType(value);
    }
  };

  const createCurrencyMappingReq = (e) => {
    const getIds = (ma, ar) => {
      let fa = [];
      let maKey = ma.map((x) => x.name);
      for (let i = 0; i < ar.length; i++) {
        fa.push(ma[maKey.indexOf(ar[i])].id);
      }
      return fa;
    };
    setcreateSet(true);
    const req = {
      actionCustomerMasterRequestVO: {
        walletOwnerId: walletOwnerID,
        trfId:
          getIds(transferTypeList, transferTypes).length == 0
            ? ""
            : getIds(transferTypeList, transferTypes),
        bankId: bankType.split("-")[0],
      },
    };
    dispatch(adminTransferTypeMappping(req, authToken));
    setwalletOwnerID("");
    setbankType("");
    settransferTypes("");
  };

  const getTransferTypeList = (id, name) => {
    setttListSet(true);
    let reqs = {
      actionCustomerMasterRequestVO: {
        id,
        name,
      },
    };
    dispatch(adminGetTransferTypeList(reqs, authToken));
  };

  useEffect(() => {
    return () => {
      dispatch(resetAdminGetTransferTypeList());
    };
  }, []);

  const chagneSearchWalletOwnerId = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    if (name === "searchWalletOwnerID") {
      setsearchWalletOwnerID(value);
    }
  };

  useEffect(() => {
    submitsearchfunc();
  }, []);

  const submitsearchfunc = () => {
    setsetSearch(true);
    setisLoading(true);
    const req = {
      actionCustomerMasterRequestVO: {
        id: "",
        mappindId: "",
        name: "",
        walletOwnerId:
          searchWalletOwnerID === "Select Owner Id" ? "" : searchWalletOwnerID,
      },
    };
    dispatch(adminGetTransferTypeMappingList(req, authToken));
    setPage(0);
  };

  const getAdminGetTransferTypeMappingListCompare = (walletOwnerID) => {
    console.log("logggg");
    const req = {
      actionCustomerMasterRequestVO: {
        id: "",
        mappindId: "",
        name: "",
        walletOwnerId: walletOwnerID,
      },
    };
    dispatch(adminTransferTypeMapppingCompare(req, authToken));
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const deleteModal = (id) => {
    setdeleteSet(true);
    const req = {
      actionCustomerMasterRequestVO: {
        mappingId: id,
      },
    };
    dispatch(adminDeleteTransferTypeMapping(req, authToken));
    setwalletOwnerID("");
    setbankType("");
    settransferTypes("");
  };

  const handleDeleteRespFunc = () => {
    if (deleteSet) {
      if (adminDeleteTransferTypeMappingRes.data.status === "success") {
        setdeleteDescription(
          adminDeleteTransferTypeMappingRes.data.description
        );
        setdeleteNotify(true);
        submitsearchfunc();
      }
      if (adminDeleteTransferTypeMappingRes.data.status === "failed") {
        setdeleteDescription(
          adminDeleteTransferTypeMappingRes.data.description
        );
        setdeleteNotify(true);
        if (
          adminDeleteTransferTypeMappingRes.data.description == "session out"
        ) {
          SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
        }
        if (
          adminDeleteTransferTypeMappingRes.data.description ==
          "Authorization failed"
        ) {
          regenerateToken(
            dispatch,
            authToken,
            regenerateTokenRes.data.partnerId
          );
        }
      }
      if (adminDeleteTransferTypeMappingRes.data.status === "NOT FOUND") {
        setdeleteDescription(
          adminDeleteTransferTypeMappingRes.data.description
        );
        setdeleteNotify(true);
      }
    }
  };

  useEffect(() => {
    handleDeleteRespFunc();
  }, [adminDeleteTransferTypeMappingRes.data.status]);

  const closeDeleteNotification = () => {
    setdeleteNotify(false);
    setdeleteDescription("");
  };

  // useEffect(() => {
  //     getBankTypeList();
  // }, [])

  const getBankTypeList = () => {
    const req = {
      actionCustomerMasterRequestVO: {
        id: "",
        accountName: "",
      },
    };
    dispatch(adminGetAccountTypeList(req, authToken));
  };

  const setDropdownAccountType = () => {
    if (adminGetAccountTypeListRes.data.status === "success") {
      setbankTypeList(
        adminGetAccountTypeListRes.data.customerMasterDetailsRequestVOList
      );
      submitsearchfunc();
      setisLoading(false);
    }
    if (adminGetAccountTypeListRes.data.status === "failed") {
      if (adminGetAccountTypeListRes.data.description == "session out") {
        SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
      }
      if (
        adminGetAccountTypeListRes.data.description == "Authorization failed"
      ) {
        regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
      }
    }
  };

  useEffect(() => {
    setDropdownAccountType();
  }, [adminGetAccountTypeListRes.data.status]);

  return (
    <>
      <Layout>
        <BackButton />
        <Card>
          <DialogTitle>Mapping Transfer Type</DialogTitle>
          <Grid
            container
            spacing={2}
            style={{ padding: "25px", marginTop: "2rem" }}
          >
            <Grid item xs={12} sm={12} md={3} lg={3}>
              <TextField
                select
                size="small"
                color="primary"
                type="text"
                variant="standard"
                label="Owner ID"
                fullWidth={true}
                name="walletOwnerID"
                value={walletOwnerID || "Select Owner Id"}
                onChange={(e) => {
                  handleChange(e);
                  getAdminGetTransferTypeMappingListCompare(e.target.value);
                }}
              >
                <MenuItem value="Select Owner Id" selected="Select Owner Id">
                  Select Owner Id
                </MenuItem>
                {walletOwnerIdResp &&
                  [].concat(walletOwnerIdResp).map((x) => (
                    <MenuItem key={x.split("-")[0]} value={x.split("-")[0]}>
                      {x}
                    </MenuItem>
                  ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3}>
              <TextField
                select
                size="small"
                color="primary"
                type="text"
                label="Bank Type"
                variant="standard"

                fullWidth={true}
                name="bankType"
                value={bankType || ""}
                onChange={(e) => {
                  handleChange(e);

                  getTransferTypeList(
                    e.target.value.split("-")[0],
                    e.target.value.split("-")[1]
                  );
                }}
              >
                <MenuItem value="" selected="Select Bank Type">
                  Select Bank Type
                </MenuItem>
                {bankTypeList &&
                  [].concat(bankTypeList).map((x, index) => (
                    <MenuItem key={index} value={`${x.id}-${x.accountName}`}>
                      {x.accountName}
                    </MenuItem>
                  ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3}>
              <FormControl
                className={classes.formControl}
                style={{ width: "100%", marginTop: "-4px" }}
              >
                <InputLabel id="multipleCountrySelect">
                  Select Transfer Type
                </InputLabel>
                <Select
                  labelId="multipleCountrySelect"
                  multiple
                  label="Transfer Type"
                  fullWidth={true}
                  value={transferTypes || []}
                  name="transferTypes"
                  input={<Input />}
                  renderValue={(selected) => selected.join(", ")}
                  onChange={handleChange}
                >
                  <MenuItem key="all" value="all">
                    <Checkbox
                      color="primary"
                      checked={
                        transferTypes.length ===
                        transferTypeList.filter((ch) => !ch.disabled).length
                      }
                    />
                    <ListItemText primary="Select All" />
                  </MenuItem>
                  {console.log("checkDs", transferTypeList)}
                  {transferTypeList &&
                    [].concat(transferTypeList).map((x, index) => {
                      return (
                        <MenuItem
                          key={index}
                          value={`${x.name}`}
                          disabled={x.disabled}
                        >
                          <Checkbox
                            color="primary"
                            checked={transferTypes.indexOf(`${x.name}`) > -1}
                          />
                          <ListItemText primary={x.name} />
                        </MenuItem>
                      );
                    })}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3}>
              <CustomButton
                style={{
                  padding: "8px",
                  margin: "8px 8px",
                }}
                variant="contained"
                onClick={createCurrencyMappingReq}
              >
                Create
              </CustomButton>
            </Grid>
          </Grid>
        </Card>
        <Card>
          <DialogTitle>Search</DialogTitle>
          <Grid container spacing={2} style={{ padding: "25px" }}>
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <TextField
                select
                size="small"
                color="primary"
                type="text"
                label="Owner ID"
                variant="standard"

                fullWidth={true}
                name="searchWalletOwnerID"
                value={searchWalletOwnerID || "Select Owner Id"}
                onChange={chagneSearchWalletOwnerId}
              >
                <MenuItem value="Select Owner Id" selected="Select Owner Id">
                  Select Owner Id
                </MenuItem>
                {walletOwnerIdResp &&
                  [].concat(walletOwnerIdResp).map((x) => (
                    <MenuItem key={x.split("-")[0]} value={x.split("-")[0]}>
                      {x}
                    </MenuItem>
                  ))}
              </TextField>
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <CustomButton
                style={{
                  padding: "8px",
                  margin: "8px 8px",
                }}
                variant="contained"
                onClick={submitsearchfunc}
              >
                Search
              </CustomButton>
            </Grid>
          </Grid>
        </Card>
        {isLoading ? (
          <LoadingSpinner />
        ) : transferTypeMappingArr.length == 0 ||
          transferTypeMappingArr == undefined ||
          !transferTypeMappingArr ||
          transferTypeMappingArr == [] ? (
          <Card>
            <Grid
              container
              style={{
                padding: "10px",
              }}
            >
              <Grid xs={12} sm={12} md={12} lg={12}>
                <Typography variant="body1" style={{ fontWeight: "700" }}
                                className="themeText"
                
                >
                  Report Table
                </Typography>
              </Grid>
              <Grid xs={12} sm={12} md={12} lg={12}>
                <Alert
                  className="my-3 tableHeaderColor"
                  variant="secondary"
                  style={{ color: "white" }}
                >
                  No Records Found!
                </Alert>
              </Grid>
            </Grid>
          </Card>
        ) : (
          <Card>
            <Grid
              container
              style={{
                padding: "10px",
              }}
            >
              <Grid xs={12} sm={12} md={12} lg={12}>
                <Typography variant="body1" style={{ fontWeight: "700" }}
                                className="themeText"
                
                >
                  Report Table
                </Typography>
              </Grid>
              <TableContainer component={Paper} className="my-3">
                <Table
                  className={classes.table}
                  size="small"
                  aria-label="a dense table"
                >
                  <TableHead>
                    <TableRow className="tableHeaderColor">
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Mapping ID
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Bank Type
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Transfer Type
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Owner Name
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Action
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {transferTypeMappingArr &&
                      []
                        .concat(transferTypeMappingArr)
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, index) => (
                          <TableRow key={index}>
                            <TableCell align="center">
                              {" "}
                              {row.mappingId}{" "}
                            </TableCell>
                            <TableCell align="center">
                              {" "}
                              {row.bankType}{" "}
                            </TableCell>
                            <TableCell align="center"> {row.name} </TableCell>
                            <TableCell align="center">
                              {row.walletOwnerName}
                            </TableCell>
                            <TableCell align="center">
                              <CustomButton
                                style={{
                                  padding: "8px",
                                }}
                                onClick={() => deleteModal(row.mappingId)}
                              >
                                <Delete style={{ color: "#fff" }} />
                              </CustomButton>
                            </TableCell>
                          </TableRow>
                        ))}
                  </TableBody>
                </Table>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={[].concat(transferTypeMappingArr).length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableContainer>
            </Grid>
          </Card>
        )}
      </Layout>

      {adminDeleteTransferTypeMappingRes.data.status == "success" && (
        <div>
          <Dialog open={deleteNotify} onClose={closeDeleteNotification}>
            <DialogContent
              className="text-center"
              style={{ backgroundColor: "#00b9f51c" }}
            >
              <img src={success} alt="" width="100px" className="my-2" />
            </DialogContent>
            <DialogContent>
              <h4
                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
              >
                {deleteDescription}
              </h4>
            </DialogContent>
            <DialogActions style={{ justifyContent: "center" }}>
              <Button
                style={{
                  margin: "10px 0",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                variant="contained"
                onClick={closeDeleteNotification}
              >
                Ok
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )}

      {adminDeleteTransferTypeMappingRes.data.status == "failed" && (
        <div>
          <Dialog open={deleteNotify} onClose={closeDeleteNotification}>
            <DialogContent
              className="text-center"
              style={{ backgroundColor: "#00b9f51c" }}
            >
              <img src={failed} alt="" width="100px" className="my-2" />
            </DialogContent>
            <DialogContent>
              <h4
                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
              >
                {deleteDescription}
              </h4>
            </DialogContent>
            <DialogActions style={{ justifyContent: "center" }}>
              <Button
                style={{
                  margin: "10px 0",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                variant="contained"
                onClick={closeDeleteNotification}
              >
                Ok
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )}

      {adminDeleteTransferTypeMappingRes.data.status == "NOT FOUND" && (
        <div>
          <Dialog open={deleteNotify} onClose={closeDeleteNotification}>
            <DialogContent
              className="text-center"
              style={{ backgroundColor: "#00b9f51c" }}
            >
              <img src={failed} alt="" width="100px" className="my-2" />
            </DialogContent>
            <DialogContent>
              <h4
                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
              >
                {deleteDescription}
              </h4>
            </DialogContent>
            <DialogActions style={{ justifyContent: "center" }}>
              <Button
                style={{
                  margin: "10px 0",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                variant="contained"
                onClick={closeDeleteNotification}
              >
                Ok
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )}

      {adminTransferTypeMappingRes.data.status == "success" && (
        <div>
          <Dialog open={notificationOpen} onClose={handleNoticationClose}>
            <DialogContent
              className="text-center"
              style={{ backgroundColor: "#00b9f51c" }}
            >
              <img src={success} alt="" width="100px" className="my-2" />
            </DialogContent>
            <DialogContent>
              <h4
                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
              >
                {mappingDescription}
              </h4>
            </DialogContent>
            <DialogActions style={{ justifyContent: "center" }}>
              <Button
                style={{
                  margin: "10px 0",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                variant="contained"
                onClick={handleNoticationClose}
              >
                Ok
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )}

      {adminTransferTypeMappingRes.data.status == "failed" && (
        <div>
          <Dialog open={notificationOpen} onClose={handleNoticationClose}>
            <DialogContent
              className="text-center"
              style={{ backgroundColor: "#00b9f51c" }}
            >
              <img src={failed} alt="" width="100px" className="my-2" />
            </DialogContent>
            <DialogContent>
              <h4
                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
              >
                {mappingDescription}
              </h4>
            </DialogContent>
            <DialogActions style={{ justifyContent: "center" }}>
              <Button
                style={{
                  margin: "10px 0",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                variant="contained"
                onClick={handleNoticationClose}
              >
                Ok
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )}
    </>
  );
};

export default AdminTransferTypeMapping;
